import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setSportLadderShow, setSportLadderTitle, setSportLadderId } from '../../store/sportEvent/sportEvent.slice'
import { requestSportLadder } from '../../store/sportEvent/sportEvent.thunks'
import { requestBetPlacingStart, requestCashOut } from "../../store/betPlacing/betPlacing.thunks";
import { setShowBetPlacingPopover, setBetPlacingPopoverStage, setDelay, setIsCashOut, setCashOutId, setCashoutMarket, setMarket, setRunner, setRunnerName, setEventName, setIsBack, setPrice, setPriceActual, setLine, setStake } from '../../store/betPlacing/betPlacing.slice';
import { setLoginNew } from '../../store/LoginNew/loginNew.slice';
import { setLoginNavigationData } from '../../store/loginNavigation/LoginNavigation.slice';
import { setIsCashOutPopup } from '../../store/cashoutPopup/cashoutPopup.slice';

export const connectSportMarketStandard = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      exposure: state.eventPage.exposure,
      exposureFancy: state.eventPage.exposureFancy,
      elementsParams: state.elementsParams,
      eventOpenBets: state.openBets.eventPageOpenBets,
      user: state.user,
      openBets: state.openBets,
      cashoutPopUp: state.cashoutPopUp,
      sportLimits: state.sportEvent.sportLimits,
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      setSportLadderShow,
      setSportLadderTitle,
      setSportLadderId,
      requestSportLadder,
      requestBetPlacingStart,
      requestCashOut,
      setShowBetPlacingPopover,
      setBetPlacingPopoverStage,
      setDelay,
      setIsCashOut,
      setCashOutId,
      setCashoutMarket,
      setLoginNew,
      setLoginNavigationData,
      setMarket,
      setRunner,
      setRunnerName,
      setEventName,
      setIsBack,
      setPrice,
      setPriceActual,
      setLine,
      setStake,
      setIsCashOutPopup
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
